module.exports = __webpack_public_path__ + "static/media/Golos_Text_Medium.c2580dc7.ttf";